(()=>{
const dialog=document.querySelector('.tos-priority-offer');if(!dialog||!dialog.showModal)return;
const root=window.Shopify.routes.root,error=dialog.querySelector('[role=alert]'),accept=dialog.querySelector('[data-priority-accept]');
let pending=false,busy=false,proceed=null,completed=false,attempt=0;
function disable(value){dialog.querySelectorAll('button').forEach(button=>button.disabled=value);}
async function request(path,options={}){
 const controller=new AbortController();let timer;
 try{return await Promise.race([(async()=>{const response=await fetch(root+path,{...options,signal:controller.signal});const data=await response.json();if(!response.ok||data.status)throw Error('cart');return data;})(),new Promise((_,reject)=>{timer=setTimeout(()=>{controller.abort();reject(Error('timeout'));},8000);})]);}
 finally{clearTimeout(timer);}
}
function showError(){error.textContent=dialog.dataset.error;error.hidden=false;}
function finish(){if(busy)return;attempt++;completed=true;dialog.close();const next=proceed;proceed=null;pending=false;disable(false);if(next)next();}
document.addEventListener('tos:before-checkout',event=>{
 if(completed)return;event.preventDefault();if(pending)return;
 pending=true;proceed=()=>event.detail.proceed();++attempt;
 error.hidden=true;accept.disabled=false;
 const img=dialog.querySelector('img');if(!img.src)img.src=img.dataset.src;
 if(typeof removeTrapFocus==='function')removeTrapFocus();
 dialog.showModal();dialog.querySelector('.tos-priority-close').focus();

});
dialog.addEventListener('click',event=>{event.stopPropagation();if(event.target.closest('[data-priority-decline]'))finish();});
dialog.addEventListener('cancel',event=>{event.preventDefault();finish();});
accept.addEventListener('click',async()=>{
 if(busy||accept.disabled)return;busy=true;disable(true);error.hidden=true;
 try{const cart=await request('cart.js');if(!cart.item_count)throw Error('empty-cart');if(!cart.items.some(item=>String(item.variant_id)===dialog.dataset.variant)){
  await request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(dialog.dataset.variant),quantity:1})});}
  busy=false;finish();
 }catch{showError();}finally{busy=false;disable(false);}
});
addEventListener('pageshow',event=>{if(!event.persisted)return;attempt++;completed=false;pending=false;busy=false;proceed=null;disable(false);if(dialog.open)dialog.close();});
})();
